import type { ElakeArvioModel } from "../../../types/ElakeArvioModel";
import type { CalculationContext } from "../calculationContext";
import { resolveAccumulationSchedule } from "./rules";
import type { PensionAccumulationResult } from "./types";
import { runYearlyAccumulationLoop } from "./yearlyLoop";

export function runAccumulation(
  model: ElakeArvioModel,
  context: CalculationContext,
): PensionAccumulationResult {
  const schedule = resolveAccumulationSchedule(model, context);
  const { state, exceptionSalaryIndex, startPriceLevel, endPriceLevel, teiNextYear } =
    runYearlyAccumulationLoop(model, context, schedule, {
      trackPriceLevels: true,
    });

  return {
    pension: state.pension,
    carryPension: state.carryPension,
    income: state.income,
    pensionYear: schedule.pensionYear,
    pensionMonth: schedule.pensionMonth,
    exceptionIndexing: schedule.exceptionIndexing,
    exceptionSalaryIndex,
    startPriceLevel,
    endPriceLevel,
    teiNextYear,
  };
}
